import { z } from 'zod';
import { AllPaymentProviderSchema } from '../common-tools';
export var PaymentMethodStatus;
(function (PaymentMethodStatus) {
    PaymentMethodStatus["ACTIVE"] = "ACTIVE";
    PaymentMethodStatus["EXPIRED"] = "EXPIRED";
    PaymentMethodStatus["FAILED"] = "FAILED";
    PaymentMethodStatus["REMOVED"] = "REMOVED";
})(PaymentMethodStatus || (PaymentMethodStatus = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["CARD"] = "CARD";
    PaymentType["ACH"] = "ACH";
    PaymentType["OTHER"] = "OTHER";
})(PaymentType || (PaymentType = {}));
export const PaymentTypeSchema = z.nativeEnum(PaymentType);
export const PaymentMethodStatusSchema = z.nativeEnum(PaymentMethodStatus);
export const PaymentMethodDataSchema = z.object({
    id: z.string(),
    providerId: z.string(),
    name: z.string(),
    type: PaymentTypeSchema,
    linkedCustomerId: z.string().nullable(),
    last4: z.string(),
    cardType: z.string().nullable(),
    bankName: z.string().nullable(),
    expiryMonth: z.number().nullable(),
    expiryYear: z.number().nullable(),
    isDefault: z.boolean(),
    isActive: z.boolean(),
    status: PaymentMethodStatusSchema,
    provider: AllPaymentProviderSchema,
});
